export const draggableBoxGrid = 'draggable-box-grid';
export const draggableBoxItem = 'draggable-box-item';
